import { atom } from 'jotai';

import { TelemedicinePanel } from './types';

export const telemedicinePanelState = atom<TelemedicinePanel>({
  isSent: false,
  isUnread: false,
  isOpenChat: false,
  isOpenProfile: true,
});
